/**
 * Profile API client
 */

import { apiClient } from "./baseClient";

// Types

export interface ProfileOnboarding {
  first_name: string;
  last_name: string;
  account_type: "user" | "partner";
  org_name?: string | null;
  is_individual: boolean;
}

export interface ProfileOrg {
  org_id: string;
  name: string;
  role: string;
}

export interface Profile {
  uid: string;
  email: string;
  email_verified: boolean;
  display_name?: string | null;
  photo_url?: string | null;
  phone?: string | null;
  locale?: string | null;
  onboarding?: ProfileOnboarding | null;
  orgs: ProfileOrg[];
  global_roles: string[];
  account_type: string;
}

export interface ProfileUpdateRequest {
  first_name?: string;
  last_name?: string;
  phone?: string;
  photo_url?: string;
  locale?: string;
}

export interface ProfileResponse {
  ok: boolean;
  profile: Profile;
}

export interface PasswordResetResponse {
  ok: boolean;
  message: string;
  link?: string; // Dev only - present when email not sent
}

// API Functions

/**
 * Get the current user's profile
 */
export async function getProfile(token: string): Promise<Profile> {
  apiClient.setAuthToken(token);
  return apiClient.get<Profile>("/profile");
}

/**
 * Update the current user's profile
 */
export async function updateProfile(
  token: string,
  data: ProfileUpdateRequest,
): Promise<ProfileResponse> {
  apiClient.setAuthToken(token);
  return apiClient.put<ProfileResponse>("/profile", data);
}

/**
 * Request password reset email
 */
export async function requestPasswordReset(
  email: string,
): Promise<PasswordResetResponse> {
  return apiClient.post<PasswordResetResponse>(
    "/profile/password/reset-email",
    {
      email,
    },
  );
}
